"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: crypto/testing/crypto-testing-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcrypto%2Ftesting%2Fcrypto-testing-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferResponse = exports.TransferRequest = exports.TransferTo = exports.SyncUserWithAdminResponse = exports.SyncUserWithAdminRequest = exports.SeedGraduationConsentEmailsResponse = exports.SeedGraduationConsentEmailsRequest = exports.GetExternalAccountsResponse = exports.GetExternalAccountsRequest = void 0;
const amount_1 = require("../../common/amount");
const crypto_1 = require("../crypto");
const protobufPackage = 'com.step.crypto.internal.proto';
function createBaseGetExternalAccountsRequest() {
    return { userId: undefined, stepAccounts: undefined };
}
exports.GetExternalAccountsRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.userId)) {
            message.userId = globalThis.String(object.userId);
        }
        if (isSet(object.stepAccounts)) {
            message.stepAccounts = globalThis.Boolean(object.stepAccounts);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== undefined) {
            obj.userId = message.userId;
        }
        if (message.stepAccounts !== undefined) {
            obj.stepAccounts = message.stepAccounts;
        }
        return obj;
    },
    create(base) {
        return exports.GetExternalAccountsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetExternalAccountsRequest();
        message.userId = object.userId ?? undefined;
        message.stepAccounts = object.stepAccounts ?? undefined;
        return message;
    },
};
function createBaseGetExternalAccountsResponse() {
    return { accounts: [] };
}
exports.GetExternalAccountsResponse = {
    fromJSON(object) {
        const message = {
            accounts: globalThis.Array.isArray(object?.accounts)
                ? object.accounts.map((e) => crypto_1.ExternalAccount.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accounts?.length) {
            obj.accounts = message.accounts.map((e) => crypto_1.ExternalAccount.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetExternalAccountsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetExternalAccountsResponse();
        message.accounts = object.accounts?.map((e) => crypto_1.ExternalAccount.fromPartial(e)) || [];
        return message;
    },
};
function createBaseSeedGraduationConsentEmailsRequest() {
    return {
        userId: '',
        twoMonthConsentSentAtMs: undefined,
        threeMonthConsentSentAtMs: undefined,
        shortNoticeConsentSentAtMs: undefined,
    };
}
exports.SeedGraduationConsentEmailsRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        if (isSet(object.twoMonthConsentSentAtMs)) {
            message.twoMonthConsentSentAtMs = globalThis.String(object.twoMonthConsentSentAtMs);
        }
        if (isSet(object.threeMonthConsentSentAtMs)) {
            message.threeMonthConsentSentAtMs = globalThis.String(object.threeMonthConsentSentAtMs);
        }
        if (isSet(object.shortNoticeConsentSentAtMs)) {
            message.shortNoticeConsentSentAtMs = globalThis.String(object.shortNoticeConsentSentAtMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.twoMonthConsentSentAtMs !== undefined) {
            obj.twoMonthConsentSentAtMs = message.twoMonthConsentSentAtMs;
        }
        if (message.threeMonthConsentSentAtMs !== undefined) {
            obj.threeMonthConsentSentAtMs = message.threeMonthConsentSentAtMs;
        }
        if (message.shortNoticeConsentSentAtMs !== undefined) {
            obj.shortNoticeConsentSentAtMs = message.shortNoticeConsentSentAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.SeedGraduationConsentEmailsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSeedGraduationConsentEmailsRequest();
        message.userId = object.userId ?? '';
        message.twoMonthConsentSentAtMs = object.twoMonthConsentSentAtMs ?? undefined;
        message.threeMonthConsentSentAtMs = object.threeMonthConsentSentAtMs ?? undefined;
        message.shortNoticeConsentSentAtMs = object.shortNoticeConsentSentAtMs ?? undefined;
        return message;
    },
};
function createBaseSeedGraduationConsentEmailsResponse() {
    return {};
}
exports.SeedGraduationConsentEmailsResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SeedGraduationConsentEmailsResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSeedGraduationConsentEmailsResponse();
        return message;
    },
};
function createBaseSyncUserWithAdminRequest() {
    return { userId: '' };
}
exports.SyncUserWithAdminRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        return obj;
    },
    create(base) {
        return exports.SyncUserWithAdminRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSyncUserWithAdminRequest();
        message.userId = object.userId ?? '';
        return message;
    },
};
function createBaseSyncUserWithAdminResponse() {
    return {};
}
exports.SyncUserWithAdminResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SyncUserWithAdminResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSyncUserWithAdminResponse();
        return message;
    },
};
function createBaseTransferTo() {
    return { userId: undefined };
}
exports.TransferTo = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.userId)) {
            message.userId = globalThis.String(object.userId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== undefined) {
            obj.userId = message.userId;
        }
        return obj;
    },
    create(base) {
        return exports.TransferTo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferTo();
        message.userId = object.userId ?? undefined;
        return message;
    },
};
function createBaseTransferRequest() {
    return { userId: '', to: exports.TransferTo.fromPartial({}), amount: amount_1.Amount.fromPartial({}) };
}
exports.TransferRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            to: isSet(object.to) ? exports.TransferTo.fromJSON(object.to) : exports.TransferTo.fromPartial({}),
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.to !== undefined) {
            obj.to = exports.TransferTo.toJSON(message.to);
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.TransferRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferRequest();
        message.userId = object.userId ?? '';
        message.to = (object.to !== undefined && object.to !== null)
            ? exports.TransferTo.fromPartial(object.to)
            : exports.TransferTo.fromPartial({});
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseTransferResponse() {
    return {};
}
exports.TransferResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.TransferResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseTransferResponse();
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=crypto-testing-service.js.map